import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { Hooks } from "@grandvisionhq/payments";
import { useCreatePaymentRequest } from "../../../../modules/ExpressCheckout/hooks/apple-pay/helper-hooks/modules/ExpressCheckout/hooks/apple-pay/helper-hooks/use-create-payment-request.js";
import { useHandleOrderCreation } from "./useHandlerOrderCreation.js";
import { useValidateAndSetOrderDetails } from "./useValidateAndSetOrderDetails.js";
const useHandleApplePay = ({
  selfUrl,
  donationInfo,
  consents,
  isSaveDetailsInAccount = false,
  setIsOrderInProgress
}) => {
  const [createPaymentRequest] = useCreatePaymentRequest(false);
  const [payCartWithApplePayActions] = Hooks.useApplePayWithActions();
  const { handlePlaceOrder } = useHandleOrderCreation();
  const { handleOrderDetailsValidation, saveCustomerInformationWithoutValidation } = useValidateAndSetOrderDetails();
  const createApplePayOrder = React.useCallback(
    async ({ paymentToken, selectedPaymentMethod }) => {
      setIsOrderInProgress(true);
      await saveCustomerInformationWithoutValidation().then(async ({ success }) => {
        if (!success) {
          setIsOrderInProgress(false);
          return;
        }
        await handlePlaceOrder({
          selectedPaymentMethod,
          paymentDetails: {
            isValid: true,
            type: selectedPaymentMethod.type,
            data: { applePayToken: paymentToken }
          },
          selfUrl,
          consents,
          donationInfo,
          isSaveDetailsInAccount,
          setIsOrderInProgress
        });
      });
    },
    [
      setIsOrderInProgress,
      saveCustomerInformationWithoutValidation,
      handlePlaceOrder,
      selfUrl,
      consents,
      donationInfo,
      isSaveDetailsInAccount
    ]
  );
  const payWithApplePay = React.useCallback(
    ({ selectedShippingMethod, consents: consents2 }) => {
      if (selectedShippingMethod.method && handleOrderDetailsValidation(selectedShippingMethod, consents2)) {
        try {
          payCartWithApplePayActions({
            createPaymentRequest,
            completePayment: createApplePayOrder
          });
        } catch (error) {
          console.error("payWithApplePay: Payment initialisation error", error);
          return;
        }
      } else {
        toast.failed("checkout.errors.form.general");
      }
    },
    [
      createApplePayOrder,
      createPaymentRequest,
      handleOrderDetailsValidation,
      payCartWithApplePayActions
    ]
  );
  return { payWithApplePay };
};
export {
  useHandleApplePay
};
//# sourceMappingURL=useHandleApplePay.js.map
